<template>
    <div>
        <div>
            <div class="mt-4">
                <qr-type v-model="style.formType"></qr-type>
            </div>

            <div class="mt-4">
                <qr-pattern :formType="style.formType"></qr-pattern>
            </div>

            <div class="mt-4">
                <marker-border></marker-border>
            </div>

            <div class="mt-4">
                <marker-center></marker-center>
            </div>

            <div class="sm:col-span-6 mt-4">
                <background-style v-model="style.backgroundColor"></background-style>
            </div>

            <div class="sm:col-span-6 mt-4">
                <foreground-style v-model="style.backgroundColor"></foreground-style>
            </div>

            <div class="sm:col-span-6 mt-4 mb-2">
                <markers-style></markers-style>
            </div>

<!--            <div class="sm:col-span-6 mt-4">-->
<!--                <logo></logo>-->
<!--            </div>-->

<!--            <div class="sm:col-span-6 mt-4">-->
<!--                <frame></frame>-->
<!--            </div>-->
        </div>
    </div>
</template>

<script>

import BackgroundStyle from "@/scripts/components/app/qrcodes/form/style/BackgroundStyle.vue";
import {mapState} from "pinia";
import {qrCodeFormStore} from "@/scripts/store/qr_code_form.store";
import ForegroundStyle from "@/scripts/components/app/qrcodes/form/style/ForegroundStyle.vue";
import QrPattern from "@/scripts/components/app/qrcodes/form/style/QrPattern.vue";
import MarkerBorder from "@/scripts/components/app/qrcodes/form/style/MarkerBorder.vue";
import MarkerCenter from "@/scripts/components/app/qrcodes/form/style/MarkerCenter.vue";
import MarkersStyle from "@/scripts/components/app/qrcodes/form/style/MarkersStyle.vue";
import Logo from "@/scripts/components/app/qrcodes/form/style/Logo.vue";
import Frame from "@/scripts/components/app/qrcodes/form/style/Frame.vue";
import QrType from "@/scripts/components/app/qrcodes/form/QrType.vue";

export default {
    components: {
        QrType,
        Logo,
        ForegroundStyle,
        BackgroundStyle,
        QrPattern,
        MarkerBorder,
        MarkerCenter,
        MarkersStyle,
        Frame,
    },

    computed: {
        ...mapState(qrCodeFormStore, ['style'])
    }
}

</script>
